import React from "react";
import { PWA } from "@/constants/testIds";
import { PROCESS_STEPS } from "./data";
import Reveal from "./Reveal";

const Process = () => {
  return (
    <section
      id="process"
      data-testid={PWA.processSection}
      className="relative bg-[#121212] text-[#FAF9F6] py-24 md:py-32 overflow-hidden wood-grain-dark"
    >
      <div className="absolute inset-0 opacity-[0.08] pointer-events-none">
        <img
          src="https://images.unsplash.com/photo-1503551723145-6c040742065b-v2.jpg"
          alt=""
          onError={(e) => (e.target.style.display = "none")}
          className="w-full h-full object-cover"
        />
      </div>

      <div className="relative w-full max-w-7xl mx-auto px-6 md:px-10 lg:px-14">
        <div className="grid lg:grid-cols-12 gap-10 items-end mb-16">
          <div className="lg:col-span-7">
            <Reveal>
              <p className="text-[11px] tracking-[0.4em] uppercase text-[#C19A6B] font-semibold mb-5">
                — Our Process
              </p>
            </Reveal>
            <Reveal delay={120}>
              <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
                From idea to <br />
                <span className="italic text-[#D9B27F]">finished piece.</span>
              </h2>
            </Reveal>
          </div>
          <Reveal delay={220} className="lg:col-span-5">
            <p className="text-[#FAF9F6]/70 text-base md:text-lg leading-relaxed font-light">
              A clear, calm process. You'll know exactly what's happening, what's next, and
              when you'll see it — from first call to final install.
            </p>
          </Reveal>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-px bg-[#FAF9F6]/10 border border-[#FAF9F6]/10">
          {PROCESS_STEPS.map((s, i) => (
            <Reveal key={s.n} delay={i * 100}>
              <div className="bg-[#121212] p-8 md:p-10 h-full flex flex-col group hover:bg-[#1A1A1A] transition-colors duration-500">
                <p className="font-serif-display text-[#D9B27F] text-6xl md:text-7xl leading-none">
                  {s.n}
                </p>
                <div className="mt-6 h-px w-12 bg-[#C19A6B] group-hover:w-20 transition-all duration-500" />
                <h3 className="mt-6 font-serif-display text-2xl md:text-3xl tracking-tight">
                  {s.title}
                </h3>
                <p className="mt-4 text-[#FAF9F6]/65 text-[15px] leading-relaxed font-light">
                  {s.body}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;
